import {
  accountNumberNumericError,
  getBankAddressIssues,
  routingNumberError,
  shouldValidateBankAddress,
  zipcodeLengthError
} from "./DrawDataLeftPanel/bankAddressValidation";

const BANK_ADDRESS_FIELDS = new Set(["city", "state"]);

export const countDrawErrors = (
  drawObj: any,
  selectedBankDetails: any,
  // Routing shown in the edit input (decrypted / typed, or stored plaintext that
  // is not a mask). Used for the 9-digit rule instead of selectedBankDetails.routing,
  // which can be a masked last-4 from a previous draw and would falsely fail.
  visibleRouting?: string
) => {
  let loanerrorCount = 0;
  const { drawAmountDetails } = drawObj;
  const fieldsToIgnore = new Set([
    "drawId", // drawId comes from route (URL), not always on draw object from API
    "drawAmountDetails",
    "balanceToFinish",
    "originatorId",
    "propertyDetailsOptions",
    "drawType",
    "loanStatus",
    "finalApproval",
    "finalApprovalNotRequired",
    "originalMaturityDate", // these fields stay excluded from required-field checks
    "maturityDate",
    "currentMaturityDate",
    "nextPaymentDueDate",
    "gracePeriod",
    "payOffRequestDate",
    "availableFinancedBudgetAmount",
    "loanExcelJson",
    "originatorName",
    "servicerId",
    "servicerName",
    "borrowerAddress",
    "requestedDate",
    "lastUpdatedDate",
    "createdAt",
    "documentTaggingStatus",
    "budgetReconcileStatus",
    "inspectionReviewStatus",
    "budgetReviewStatus",
    "prePurchaseDrawAmount",
    "brokerName",
    "originatingEntity",
    "sellerName",
    "fundingChannel",
    "fpiFlag",
    "repeatBorrower",
    "repeatBankDetailsDrawList",
    "losDrawId",
    "drawAmountType"
  ]);

  Object.keys(drawObj).forEach((field) => {
    if (fieldsToIgnore.has(field)) return;

    // Special handling for propertyDetails: require at least one property selected.
    if (field === "propertyDetails") {
      const props = drawObj.propertyDetails;
      if (!Array.isArray(props) || props.length === 0) {
        console.error("field Error:", field);
        loanerrorCount += 1;
      }
      return;
    }

    if (!drawObj[field]) {
      console.error("field Error:", field);
      loanerrorCount += 1;
    }
  });

  Object.keys(drawAmountDetails).forEach((field) => {
    if (["edited", "stage", "comments"].includes(field)) return;
    let isZeroNetFunds = false;
    if (field === "netFundsToBorrower") {
      isZeroNetFunds = drawAmountDetails[field] === "0.00";
    }

    if (
      (!drawAmountDetails[field] && drawAmountDetails[field] !== 0) ||
      isZeroNetFunds
    ) {
      console.error("field Error:", field);
      loanerrorCount += 1;
    }
  });

  if (selectedBankDetails) {
    // Drafts always run city/state/zip checks. Other stages use the submitted-date
    // cut-off (requestedDate), matching draw-service.
    const addressMandatory = shouldValidateBankAddress(drawObj);
    Object.keys(selectedBankDetails).forEach((field) => {
      if (
        [
          "netFundsToBorrower",
          "edited",
          "bankDetailId",
          "borrowerEntityName",
          "updatedBy",
          "needsDrawIdDecrypt",
          "accountNumberEncryptionId",
          "routingEncryptionId",
          "accountNameEncryptionId",
          "isEncrypted",
          "losBankDetailId",
          "country"
        ].includes(field)
      )
        return;
      // Zipcode is optional: leaving it blank is never an error. A value that was
      // entered must be the full length — but only when address checks apply.
      if (field === "zipcode") {
        if (
          addressMandatory &&
          zipcodeLengthError(selectedBankDetails[field])
        ) {
          console.error("field Error:", field);
          loanerrorCount += 1;
        }
        return;
      }
      if (BANK_ADDRESS_FIELDS.has(field)) return;
      if (!selectedBankDetails[field]) {
        console.error("field Error:", field);
        loanerrorCount += 1;
        return;
      }
      if (field === "routing") {
        // Validate the value the user actually sees in the input. When visibleRouting
        // is empty the field still shows a stored mask (last-4 / stars) — whose real
        // routing is a valid 9-digit number — so the presence check above is enough
        // and we don't flag the 9-digit rule here. Excel-uploaded plaintext that is
        // not 9 digits is published as visibleRouting and is flagged below.
        if (routingNumberError(visibleRouting)) {
          console.error("field Error:", field);
          loanerrorCount += 1;
        }
        return;
      }
      if (
        field === "accountNumber" &&
        accountNumberNumericError(selectedBankDetails[field])
      ) {
        console.error("field Error:", field);
        loanerrorCount += 1;
      }
    });
    getBankAddressIssues(selectedBankDetails, addressMandatory).forEach(
      (field) => {
        console.error("field Error:", field);
        loanerrorCount += 1;
      }
    );
  } else {
    loanerrorCount += 4;
  }
  return loanerrorCount;
};